import React, { ComponentType, ForwardRefExoticComponent } from 'react';
import { RegisterOptions } from 'react-hook-form';

import { FormGroup, FormGroupEssentialProps } from '../../../components/FormGroup/FormGroup';
import { FormFieldElement } from '../../../types';

import { BaseFieldProps, checkFormContext } from './connectFields.utils';

export type FormContextConnectorProps = {
  rules?: RegisterOptions;
} & FormGroupEssentialProps;

/**
 * This function allows to replace the usual `forwardRef` function with analog
 * that automatically registers the field if it is present in the form context
 */
export function connectFormField<Element extends FormFieldElement, Props extends BaseFieldProps<any, Element>>(
  Component: ForwardRefExoticComponent<Props> | ComponentType<Props>
) {
  const FormContextConnector = ({
    rules = {},
    name,
    onChange,
    extendedClassNames,
    isLoading,
    inline,
    label,
    helper,
    ...props
  }: Props & FormContextConnectorProps) => {
    const { validity, validationMessage, registerValues, defaultValue } = checkFormContext({
      name: name as string,
      rules,
      valid: props.valid,
      required: props.required,
      defaultValue: props.defaultValue,
    });

    // TODO: consider refactoring(as stateful) since register values return next properties
    //  onChange: ChangeHandler;
    //  onBlur: ChangeHandler;
    //  ref: RefCallBack;
    //  name: InternalFieldName;
    //  min?: string | number;
    //  max?: string | number;
    //  maxLength?: number;
    //  minLength?: number;
    //  pattern?: string;
    //  required?: boolean;
    //  disabled?: boolean;

    return (
      <FormGroup
        name={name as string}
        valid={validity}
        label={label}
        helper={helper}
        inline={inline}
        extendedClassNames={extendedClassNames}
        validationMessage={validationMessage}
        isLoading={isLoading}
      >
        <Component
          {...(props as Props)}
          name={name}
          defaultValue={defaultValue}
          onChange={(value, e) => {
            e && registerValues.onChange && registerValues.onChange(e);

            onChange && onChange(value, e);
          }}
          valid={validity}
          ref={registerValues.ref}
        />
      </FormGroup>
    );
  };

  FormContextConnector.displayName = 'FormContextConnector';

  return FormContextConnector;
}
